import { Instance } from 'mobx-state-tree';
import { ServiceAccountDtoModelBase } from './ServiceAccountDtoModel.base';

/* The TypeScript type of an instance of ServiceAccountDtoModel */
export interface ServiceAccountDtoModelType extends Instance<typeof ServiceAccountDtoModel.Type> { }

/* A graphql query fragment builders for ServiceAccountDtoModel */
export { selectFromServiceAccountDto, serviceAccountDtoModelPrimitives, ServiceAccountDtoModelSelector } from './ServiceAccountDtoModel.base';

/**
 * ServiceAccountDtoModel
 */
export const ServiceAccountDtoModel = ServiceAccountDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
